import { BuildingKayaContent } from "../../components/building";


export default function BuildingKaya() {

  return (
    <>
      <BuildingKayaContent/>
    </>
  )

}